import { createAction } from 'redux-actions'
import * as types from './actionTypes'

export const enableManyInvitesAtOnce = () => ({
  type: types.UI_ENABLE_MANY_INVITES_AT_ONCE,
})

export const scrollBodyTo = to => ({
  type: types.UI_SCROLL_BODY_TO,
  payload: {
    to,
  },
})

export const changeWindowSizes = (width, height) => ({
  type: types.UI_CHANGE_WINDOW_SIZES,
  payload: {
    width,
    height,
  },
})

export const clearLoginError = createAction('UI/CLEAR_LOGIN_ERROR')
